import { fmtDate, money } from "../api";
import { useLang, useT } from "../i18n";
import { Head, initials, useApi, useShell } from "../ui";

interface Client { name: string; email: string; phone?: string; trips: number; booked: number; valueMinor: number; currency: string; lastAt: string; next?: string }

/** Clients (docs/37 §1): the people the partner quoted for, their trips and what they booked. */
export function Clients() {
  const t = useT();
  const lang = useLang();
  const { go } = useShell();
  const { data } = useApi<{ clients: Client[] }>("/clients");
  const list = data?.clients ?? [];
  return (
    <>
      <Head eyebrow={t("clients.eyebrow")} title={t("nav.clients")} extra={<button className="btn ink" type="button" onClick={() => go("builder")}>{t("trips.new")}</button>} />
      {list.length ? (
        <div className="tbl-wrap"><table className="bk" data-testid="clients">
          <thead><tr><th>Client</th><th>Contact</th><th>Trips</th><th style={{ textAlign: "right" }}>Booked</th><th>Next departure</th><th>Last activity</th></tr></thead>
          <tbody>{list.map((c) => <tr key={c.email}><td><span className="avatar" style={{ marginRight: ".5rem" }}>{initials(c.name)}</span><b>{c.name}</b></td><td>{c.email}{c.phone ? <><br /><span className="muted">{c.phone}</span></> : null}</td><td>{c.trips}</td><td style={{ textAlign: "right" }}>{c.booked ? money(c.valueMinor, c.currency) : "—"}</td><td>{fmtDate(c.next, lang)}</td><td>{fmtDate(c.lastAt, lang)}</td></tr>)}</tbody>
        </table></div>
      ) : <div className="card empty"><b>{t("clients.none")}</b></div>}
      <p className="src">Traveller details, documents and payments of a booking are with the Booking Desk; send a change from Bookings.</p>
    </>
  );
}
